import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=f0388daa&scoped=true&"
import script from "./orderlist.vue?vue&type=script&lang=js&"
export * from "./orderlist.vue?vue&type=script&lang=js&"
import style1 from "./orderlist.vue?vue&type=style&index=1&id=f0388daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0388daa",
  null
  
)

export default component.exports